import {Component, Inject} from 'ng-metadata/core';
import {NewspapersService} from '../newspapers.service';
import {beacon, PrimolyticsService} from "../../analytics/primolytics.service";

@Component({
    selector: 'prm-newspapers-spotlight',
    templateUrl: 'components/newspapers/newspapersSpotlight/newspapers-spotlight.html',
})

export class PrmNewspapersSpotlight{
    private thumbnail:string =  'img/icon_newspapers.png';

    constructor(private newspapersService: NewspapersService,
                private primolyticsService: PrimolyticsService,
                @Inject('availabilityLineIcons') private availabilityLineIcons,
                @Inject('$state') private $state: angular.ui.IStateService) {
    }

    @beacon({ 'p': 'general', 'op': 'goToNewspapersfromRegularSearch' })
    private goToNewspapers(){
        this.newspapersService.addCameFromGoToNewspapersfromRegularSearch('bottomResultList');
        this.newspapersService.goToNewspapersFromSearch();
    }
}


// WEBPACK FOOTER //
// ./src/main/webapp/components/newspapers/newspapersSpotlight/newspapersSpotlight.directive.ts